/**
 * Places .cart-count immediately after the bag icon in each .nav-top so it is a sibling of .vaco-bag.
 */
export default function initNavTopCartCount() {
  document.querySelectorAll('.nav-top').forEach((nav) => {
    const bagIcon = nav.querySelector('[data-icon="vaco-bag"]');
    const cartCount = nav.querySelector('.cart-count');
    if (!bagIcon || !cartCount) {
      return;
    }
    bagIcon.classList.add('vaco-bag');
    bagIcon.after(cartCount);
  });
}
